export default "__VITE_ASSET__41b0e93f__"